import React from "react";
import { ArrowRight } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet";
import "../../../src/assets/css/careers.css";
// D:\Simplifyte\Website-www.simplifyte.com\src\assets\css\careers.css
const HeroSection = ({ onApplyClick }) => {
  const scrollToPositions = () => {
    document
      .getElementById("ourpositions")
      ?.scrollIntoView({ behavior: "smooth" });
  };

  const navigate = useNavigate();

  return (
    <>
      <Helmet>
        <title>Careers at Simplifyte | Build the Future With Us</title>
      </Helmet>
      <div className="hero-container-carrers px-[16px] md:px-[32px]">
        {/* <span className="carrers_badge">WE'RE HIRING</span> */}
        <h1 className="heading_carrers text-[#093a5b] font-bold mt-8 mb-4">
          Build the Future
          <br />
          With Us
        </h1>

        <p className="hero-subtitle">
          Join a team of innovators, creators, and dreamers who are redefining
          what's possible in technology.
        </p>

        <div className="hero-buttons">
          <button
            // onClick={onApplyClick}
            onClick={scrollToPositions}
            className="hero-button-open"
          >
            <span>View Open Positions</span>
            <ArrowRight className=" group-hover:translate-x-2 duration-300" />
          </button>

          <button
            onClick={() => navigate("/about")}
            className="hero-button-about-us"
          >
            <span>Learn About Us</span>
          </button>
        </div>

        <div className="scroll-indicator">
          {/* <div className="scroll-box">
          <div className="scroll-dot"></div>
        </div> */}
        </div>

        {/* Embedded CSS */}
        <style>{`
        .hero-container-carrers {
          position: relative;
          width: 100%;
          text-align: center;
          margin-top: 10rem;
        }
          @media(max-width:640px){
          .hero-container-carrers{
          margin-top: 8rem;
          }
          }
          .heading_carrers{
          font-size:70px;
          line-height:1.2;
          }
          @media(max-width:640px){
          .heading_carrers{
          font-size:35px;
          }
          }
        .hero-title {
          color: #093a5b;
          font-weight: bold;
          font-size: 3rem;
          line-height: 1.2;
          margin-bottom: 1.5rem;
        }
        .hero-subtitle {
          color: #093a5b;
          font-size: 16px;
          max-width: 700px;
          margin: 0 auto 3rem auto;
          line-height: 1.2;
        }
           @media(max-width:640px){
          .hero-subtitle{
          font-size:16px;
          }
        }
        .hero-buttons {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          gap: 1rem;
          margin-bottom: 4rem;
        }
          @media(max-width:640px){
          .hero-buttons{
          margin-bottom:2rem
          }
          }
        .btn-primary {
          display: flex;
          align-items: center;
          gap: 0.5rem;
          padding: 1rem 2rem;
          border-radius: 50px;
          background: #093a5b;
          color: white;
          font-weight: 500;
          cursor: pointer;
          border: none;
          box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
          transition: 0.3s ease;
        }
        .btn-primary:hover {
          box-shadow: 0 6px 18px rgba(0, 0, 0, 0.3);
        }
        .icon-arrow {
          transition: transform 0.3s ease;
        }
        .btn-primary:hover .icon-arrow {
          transform: translateX(4px);
        }
        .btn-secondary {
          padding: 1rem 2rem;
          border-radius: 50px;
          border: 2px solid #093a5b;
          background: transparent;
          cursor: pointer;
        }
        .btn-secondary a {
          text-decoration: none;
          color: #093a5b;
          transition: 0.3s ease;
        }
        .btn-secondary:hover a {
          opacity: 0.7;
        }
        .scroll-indicator {
          position: absolute;
          bottom: -3rem;
          left: 50%;
          transform: translateX(-50%);
        }
        .scroll-box {
          width: 28px;
          height: 48px;
          border: 2px solid rgba(9, 58, 91, 0.5);
          border-radius: 999px;
          display: flex;
          justify-content: center;
          padding-top: 6px;
          animation: bounceSlow 1.6s infinite ease-in-out;
        }
        .scroll-dot {
          width: 6px;
          height: 6px;
          background: #093a5b;
          border-radius: 50%;
          animation: bounceFast 1.6s infinite ease-in-out;
        }
        @keyframes bounceFast {
          0%, 100% { transform: translateY(0); }
          50% { transform: translateY(12px); }
        }
        @keyframes bounceSlow {
          0%, 100% { transform: translateY(0); }
          50% { transform: translateY(6px); }
        }

        /* Responsive Styles */
        @media (min-width: 640px) {
          .hero-title { font-size: 4rem; }
          .hero-subtitle { font-size: 1.4rem; }
          .hero-buttons { flex-direction: row; }
        }
        @media (min-width: 768px) {
          .hero-title { font-size: 5rem; }
          .hero-subtitle { font-size: 1.5rem; max-width: 800px; }
        }
        @media (min-width: 1024px) {
          .hero-title { font-size: 5rem; }
          .hero-subtitle { font-size: 1.125rem; }
          .hero-buttons { gap: 1.5rem; }
        }
      `}</style>
      </div>
    </>
  );
};

export default HeroSection;
